import { useRef, useState, useEffect, useCallback } from 'react';

export const NODE_WIDTH = 285;
export const NODE_HEIGHT = 358;
export const VERTICAL_GAP = 24;
export const HORIZONTAL_GAP = 24;
export const LEFT_MARGIN = 25;
export const TOPBAR_HEIGHT = 60;

export const BREAKPOINT_LARGE = 700;

export const createGridLayout = (tableFieldList: any[], containerWidth: number) => {

  if (!tableFieldList?.length || !containerWidth) return [];

  const nodesPerRow = calculateNodesPerRow(containerWidth);

  return tableFieldList && tableFieldList?.map((item: any, index: number) => {
    const row = Math.floor(index / nodesPerRow);
    const col = index % nodesPerRow;
    const header = item.tablename || item.table_name || "";
    const showTooltip = header.length > 22;

    return {
      id: header,
      type: "customNode",
      data: {
        header: header,
        content: item.columns,
        showTooltip: showTooltip,
      },
      position: {
        x: LEFT_MARGIN + (col * (NODE_WIDTH + HORIZONTAL_GAP)),
        y: TOPBAR_HEIGHT + (row * (NODE_HEIGHT + VERTICAL_GAP)),
      },
      className: "querybuilder-node",
      draggable: false,
    };
  });
};


export const calculateNodesPerRow = (containerWidth: number): number => {
  const baseNodesPerRow = containerWidth >= BREAKPOINT_LARGE ? 6 : 5;

  const availableWidth = containerWidth - (LEFT_MARGIN * 2);
  const totalNodeWidth = NODE_WIDTH + HORIZONTAL_GAP;
  const maxNodesPerRow = Math.floor(availableWidth / totalNodeWidth);

  return Math.min(baseNodesPerRow, Math.max(1, maxNodesPerRow));
};

export const getResponsiveGridLayout = (nodes: any[], containerWidth: number) => {
  const nodesPerRow = calculateNodesPerRow(containerWidth);

  return nodes.map((node, index) => {
    const row = Math.floor(index / nodesPerRow);
    const col = index % nodesPerRow;

    return {
      ...node,
      position: {
        x: LEFT_MARGIN + (col * (NODE_WIDTH + HORIZONTAL_GAP)),
        y: TOPBAR_HEIGHT + (row * (NODE_HEIGHT + VERTICAL_GAP)),
      },
      draggable: false,
      connectable: false,
      type: "customNode",
    };
  });
};

export const useDebounceFunction = (func: Function, wait: number) => {
  const timeout = useRef<NodeJS.Timeout>();

  return useCallback((...args: any[]) => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(() => func(...args), wait);
  }, [func, wait]);
};

export const useContainerWidth = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(1200);

  const updateContainerWidth = useDebounceFunction(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  }, 200);

  useEffect(() => {
    updateContainerWidth(); // Initial call
    window.addEventListener("resize", updateContainerWidth);
    return () => window.removeEventListener("resize", updateContainerWidth);
  }, [updateContainerWidth]);

  return { containerRef, containerWidth };
};